// import './js/accessibility'
import store from './js/store';
import {sticky} from './js/sticky';

import * as $ from 'jquery';
import * as lity from 'lity';
import 'lazysizes';

// import './js/quiz';
import './js/tabs';


import './templates/site-head/main';
import './templates/sections/testimonials/index';
import './templates/sections/exhibitors/index'
import './templates/sections/team/index';
import './templates/sections/news/index';
import './templates/sections/map/index';
import './templates/sections/alumni_carousel/index';
import './templates/sections/quiz/index';

import './templates/sections/benefits/index';
import './templates/sections/slideshow/index';

import './templates/testimonial/index';

import './templates/related/index';
import './templates/firefish/meta';
import './templates/cookie-bar/index';

import './templates/site-foot/newsletter';

/*if(!Modernizr.template) {
  $('template').attr('aria-hidden','true').css('display','none');
}*/


var siteHead = document.getElementById('site-head')
if(siteHead) {
  siteHead.sticky = new sticky({
    elem:            siteHead,
    container:       store.body,
    fixSpacing:      true,
    clearElem:       '#cookie-bar',
    additional:      96,
    additionalClass: 'site-head__scrolled',
  });
}



const updateQueryString = (function(key, value, url) {
  if (!url) { url = window.location.href; }

  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      return url.replace(re, '$1' + key + "=" + value + '$2$3');
    } else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');

      if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
        url += '#' + hash[1];
      }

      return url;
    }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = hash[0] + separator + key + '=' + value;

      if (typeof hash[1] !== 'undefined' && hash[1] !== null)  {
        url += '#' + hash[1];
      }

      return url;
    } else {
      return url;
    }
  }
});


let currentFilter = window.currentFilter || {
  region:     null,
  city:       null,
  discipline: null,
};

let filterCities = window.allCities || {};
let currentLocation = window.location.href;
let ajaxUrl = window.adminajax.url;

const $jobsList = $('#jobs-list'),
      $jobsFilter = $('#job-filter');

const filterJobs = (function() {

  const location   = currentFilter.region,
        discipline = currentFilter.discipline,
        city       = currentFilter.city;

  $('#jobs-list').attr('aria-busy', true).addClass('loading');

  var url = currentLocation;
  $.each(currentFilter, (key, value) => {
    url = updateQueryString(key, value, url);
  });

  $.ajax({
    url: ajaxUrl,
    data: {
      action: 'filter_firefish_job',
      region: location,
      discipline,
      city
    },
    accepts: 'text/html',
    cache: false,
    complete: (response, status) => {

      var content = response.responseText;
      $('#jobs-list').replaceWith(content);
      $('#jobs-list').attr('aria-busy', false);

    },
  });

  history.replaceState({jobFilter: currentFilter}, $('title').html(), url);
});

if($jobsFilter.length > 0) {

  $('select', $jobsFilter).on('change', function(e) {
    e.preventDefault();

    const category = $(this).attr('name'),
          value    = $(this).val();

    currentFilter[category] = value!=="*"?value:null;

    if(category === 'city') {

      var $value = $('option:selected', this),
          $group = $value.closest('optgroup');

      if($group.length) {

        var currentRegion = $group.attr('data-region');
        currentFilter['region'] = currentRegion;

        $('input[name="region"]').prop('checked', false);

        $(`input[name="region"][value="${currentRegion}"]`, $jobsFilter).prop('checked', true);
        $(`select[name="region"]`, $jobsFilter).val(currentRegion);
      }

    } else if (category === 'region') {

      $(`input[name="region-radio"]`).removeProp('checked');
      $(`input[name="region-radio"][value="${value}"]`).prop('checked', true);
      $(`select[name="region"]`).val(value);

      currentFilter['city'] = null;
      $('select[name="city"]', $jobsFilter).val('*');

      var currentRegions = typeof filterCities[value] !== 'undefined' ? [filterCities[value]] : filterCities;

      $('select[name="city"] optgroup', $jobsFilter).remove();

      $.each(currentRegions, (i, region) => {
        var optgroup = document.createElement('optgroup');
        optgroup.setAttribute('label', region.title);
        optgroup.setAttribute('data-region', region.slug);

        $.each(region.cities, (citySlug, city) => {
          $(optgroup).append(`<option value="${citySlug}">${city}</option>`);
        });

        $('select[name="city"]', $jobsFilter).append(optgroup);
      });

    }

    filterJobs();
  });

  $('input[name="region-radio"]', $jobsFilter).on('change', function(e) {
    const $this = $(this),
          value = $this.val();

    $('select[name="region"]', $jobsFilter).val(value).change();
  });
}



let $newsletterForm = $('form[data-nl-signup]');
if($newsletterForm.length > 0) {

  /*if(typeof(window.f24) !== "function") {
    $newsletterForm.each(function() {
      const $this = $(this);
      $this.before(`<div class="wrap"><div class="wpcf7-not-valid-tip p"><h2 class="epsilon m-bottom--none text-color--white">Something has stopped this form from working properly.</h2>It could be that you are running an ad or content blocker that’s inadvertantly breaking it. Try temporarily turning off your content blocker, and try again.</div></div>`);
      $this.remove();
    });
  }*/

  store.$app.on('change', 'form[data-nl-signup] input[type="checkbox"], form[data-nl-signup] input[type="radio"]', function(e) {
    const $this    = $(this),
          $form    = $this.closest('form[data-nl-signup]'),
          name     = $this.attr('name').replace('[]', ''),
          $elem    = $(`input[name="${name}-field"]`, $form),
          $checked = $(`input[name="${name}[]"]:checked`, $form);

    var values = [];

    for(var i = 0; i < $checked.length; i++) {
      values.push($checked[i].value);
    }

    $elem.val(values.join(', '));
  });

  $newsletterForm.on('submit',function(e) {
    e.preventDefault();

    const $this = $(this),
          id    = $this.attr('id');

    if($this.hasClass('loading')) { return false; }

    const returnUrl = $this.attr('action');

    $this.addClass('loading');

    $.ajax({
      url:  `${window.adminajax.url}?action=newsletter_signup`,
      data: $this.serialize(),
      dataType: 'json',
      method: 'post',
      complete: (function(xhr, status) {

        var data = xhr.responseJSON;

        if(!!returnUrl && status !== 'error') {
          window.location.href = `${returnUrl}${returnUrl.includes("?")?"&":"?"}result=${status}&template-submit=false`;
          return false;
        }

        $this.removeClass('loading');

        $this.append(`<div class="newsletter-notice newsletter-notice--${status}" style="display:none">`);
        const $return = $this.find('.newsletter-notice:last-child');

        $return.html(data.message);
        $return.slideDown(250);

        setTimeout(() => {
          $return.slideUp(250, function() {
            $(this).remove();
          });
        }, 7500);

      }),

    });

    return false;
  });
}


store.$app.on("click", '.social-item__media a', function(e) {
  e.preventDefault();

  const $this = $(this),
        url   = $this.attr('href');

  lity(url, {
    handler: 'image'
  }, this);
});





store.$app.on("click", 'a[data-embed-link]', function(e) {
  e.preventDefault();

  const $this = $(this),
        url   = $this.attr('data-embed-link');

  lity(url, {
    handler: 'iframe'
  }, this);
});




store.$app.on("click", 'a[data-embed]', function(e) {
  e.preventDefault();

  const $this = $(this),
        element = $this.attr('data-embed'),
        $elem = $(element),
        $node = $($elem.prop('content')).clone();

  let node = $node,
      handler = 'inline';

  if($node.find('iframe').length > 0) {

    handler = 'iframe';
    node = $node.find('iframe').first().attr('src');

  } else {
    node = $('<div>').append($node).html();
  }

  var instance = lity($node, {
    handler
  }, this);
});



store.$app.on('change', '[data-select-redirect]', function(e) {
  e.preventDefault();
  window.location.href = $(this).val();
});
